// extracted by css-extract-rspack-plugin
export default {"title":"_6f1d5bdd","page":"_be78712e","footer":"_7a604118"};